module.exports = __webpack_public_path__ + "static/media/moons_expansion.0bd5512b.svg";